import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "unarchive-modal" */'./UnarchiveModal').then(mod => mod.default),
  LoadingComponent: () => null
});